module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray@3x-fdb4793dfd1a5996be03d8259f9e8891.png";